<template>
    <div class="container-fluid">
        <router-view :phases = "phasesWithRoutes" :lastPageId = "16"></router-view>
    </div>
</template>

<script>
export default {
    name: "QuestionView",
    data: function() {
        return{
            phases:[],
            phasePages:[],
            phasesWithRoutes:[],
            lastPageId: -1
        }
    },
    //runs automatically when the page loads...
    created() {
        this.fetchPhases();
    },
    methods:{
       fetchPhases(){
            let vm = this;
            axios
                .get("/api/phases")
                .then(response => {
                    this.phases = response.data;
                    console.log("this.phases:");
                    console.log(this.phases);
                    axios
                        .get("/api/phaseQuestionPages")
                        .then(responsePages => {
                            this.phasePages = responsePages.data;
                            console.log("this.phasePages:");
                            console.log(this.phasePages);
                            this.createRoutes();
                        })
                        .catch(err => console.log(err));
                })
                .catch(err => console.log(err));                 
       },
        createRoutes(){
           console.log("function createRoutes entered") ;
           this.phasesWithRoutes = this.phasePages.map(phasePage => (
                {
                   phase: this.getPhaseFromPhasePage(phasePage.PhaseId),
                   route: phasePage.Page
                }));
           console.log(this.phasesWithRoutes);
           this.lastPageId = this.phasesWithRoutes[this.phasesWithRoutes.length - 1].route;
           console.log("lastPageId:");
           console.log(this.lastPageId);
        },
        getPhaseFromPhasePage(phaseId){  
            return this.phases.find(phase => {
                return phase.Id == phaseId;
            });
        }
    }
};
</script>